import React, { useState, useEffect } from "react";
import {
  TableCell,
  TableRow,
  Table,
  Collapse,
  Box,
  Typography,
  TableHead,
  TableBody,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";

const Row = ({ row }) => {
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [payments, setPayments] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (searchParams.get("tab") == "unpaid") {
      if (row.has_paid == 1) {
        setStatus("Μερικώς Πληρωμένη");
      } else {
        setStatus("Απλήρωτη");
      }
    } else {
      if (row.status == 3) {
        setStatus("Σε Εκρεμμότητα");
      } else if (row.status == 8) {
        setStatus("Εμβασματοποιημένη");
      } else if (row.status == 9) {
        setStatus("Ελλατωματική Πληρωμή");
      } else {
        setStatus("Εκρεμμεί Επαλήθευση");
      }
    }
  }, []);

  useEffect(() => {
    if (open) {
      (async () => {
        setLoading(true);
        try {
          const response = await axios.request(
            `${process.env.REACT_APP_BACKEND_URL}/paymentDetails`,
            {
              params: {
                tab: searchParams.get("tab"),
                kede_debt_id: row.id,
              },
              withCredentials: true,
            },
          );

          setPayments(response.data);
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [open]);

  return (
    <>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">{row.id}</TableCell>
        <TableCell align="center">{row.afm}</TableCell>
        <TableCell align="center">
          <Link to={row.registryUrl} target="_blank">
            {row.registryUrl.split("/")[5]}
          </Link>
        </TableCell>
        <TableCell align="center">{row.amount} &euro;</TableCell>
        <TableCell align="center">{status}</TableCell>
        <TableCell align="center">{row.chamber}</TableCell>
        <TableCell align="center">{row.fiscal_year}</TableCell>
        <TableCell align="center">
          {moment(new Date(row.date_validated)).format("YYYY-MM-DD")}
        </TableCell>
        {searchParams.get("tab") == "paid" && (
          <TableCell align="center">
            {moment(new Date(row.date_paid)).format("YYYY-MM-DD")}
          </TableCell>
        )}
        <TableCell align="center">
          {row.has_paid == 1 || searchParams.get("tab") == "paid" ? (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          ) : (
            <Typography variant="h5">-</Typography>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={searchParams.get("tab") == "unpaid" ? 9 : 10}
        >
          <Collapse
            in={open}
            sx={{ backgroundColor: "#F6F6F6" }}
            timeout="auto"
            unmountOnExit
          >
            {loading ? (
              <CircularProgress size={25} sx={{ ml: "45%", p: 5 }} />
            ) : (
              <Box
                sx={{
                  p: 1,
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ mt: 2 }}
                  gutterBottom
                  component="div"
                >
                  Πληρωμές
                </Typography>
                <Table
                  size="small"
                  sx={{
                    maxHeight: "20%",
                    mt: 4,
                    width: "70%",
                    "& .MuiTableCell-head": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">ID Πληρωμής</TableCell>
                      <TableCell align="center">Ποσό</TableCell>
                      <TableCell align="center">Προσαυξήσεις</TableCell>
                      <TableCell align="center">Ημερομηνία Πληρωμής</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {payments &&
                      payments.map((payment, index) => (
                        <TableRow key={index}>
                          <TableCell align="center" component="th" scope="row">
                            {payment.id}
                          </TableCell>
                          <TableCell align="center">
                            {payment.amount} &euro;
                          </TableCell>
                          <TableCell align="center">
                            {payment.overdue_amount} &euro;
                          </TableCell>
                          <TableCell align="center">
                            {moment(new Date(payment.date_created)).format(
                              "YYYY-MM-DD",
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default Row;
